import { BoxProps, HStack } from '@chakra-ui/react'

export default function Card({ children, ...props }: { children: React.ReactNode } & BoxProps) {
  return (
    <HStack
      borderRadius="16px"
      fontWeight="semibold"
      p="6"
      w="100%"
      justify="space-between"
      bg="whiteAlpha.200"
      backdropFilter="blur(25px)"
      {...props}
    >
      {children}
    </HStack>
  )
}
